import { useState } from "react";
import { AnimatePresence } from "framer-motion";

import useChatbot from "../hooks/useChatbot";

import ChatButton from "../components/chatbot/ChatButton";
import ChatWindow from "../components/chatbot/ChatWindow";

export default function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);

  const {
    messages,
    typing,
    sendMessage,
    handleOptionClick,
    bottomRef,
  } = useChatbot();

  const toggleChat = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      {/* Floating Button */}
      {!isOpen && (
    <ChatButton
      isOpen={isOpen}
      toggleChat={toggleChat}
    />
  )}

  <AnimatePresence>
    {isOpen && (
      <ChatWindow
        messages={messages}
        typing={typing}
        sendMessage={sendMessage}
        handleOptionClick={handleOptionClick}
        bottomRef={bottomRef}
        onClose={toggleChat}
      />
    )}
  </AnimatePresence>
    </>
  );
}